'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = secure3dDepositAPIv2;

var _PaymentsApi = require('../PaymentsApi');

var _secure3dDepositAPI = require('./secure3dDepositAPI');

var _secure3dDepositAPI2 = _interopRequireDefault(_secure3dDepositAPI);

var _DSv2helpers = require('../3DSv2helpers');

var helper = _interopRequireWildcard(_DSv2helpers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** perform3dsDepositAPI v2
 * @returns {void}
 * **/
function secure3dDepositAPIv2() {
  var secureDepositV1 = (0, _secure3dDepositAPI2.default)();

  /**
   * Start challenge. Creates hidden iframe and posts 3DSv2 data
   * @param {string} creq - received from frictionless response
   * @param {string} acsUrl - url to acs received from frictionless response
   * @param {string} threedsSessionData - 3dsv2 session data
   * @returns {Promise}
   **/
  function startChallenge(creq, acsUrl, threedsSessionData) {
    return new _promise2.default(function (resolve, reject) {
      helper.challengeRedirection(creq, acsUrl, threedsSessionData).then(function (data) {
        resolve((0, _extends3.default)({}, data, {
          threedsSessionData: data.threedsSessionData || threedsSessionData
        }));
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  /** create3ds2FrictionlessIframe
   * @param {TdsDetailsType} threeDSMethodData - Token to perform deposit
   * @param {TdsDetailsType} threeDSv2RedirectURL - received from PerformDeposit
   * @returns {void}
   * **/
  function createFrictionlessIframe(threeDSMethodData, threeDSv2RedirectURL) {
    helper.start3DSv2Process(threeDSMethodData, threeDSv2RedirectURL);
  }

  /** frictionlessRequest
   * @param {string} cardId - Card ID
   * @param {string} pmtId - Openbet's Payment ID
   * @param {string} threeDSv2Token  - The threeDSv2Token value from the InitPaymentAuthResponse
   * e.g. "123456ab-abcd-abc1-123a456b7cd89e0f"
   * @param {string} txnId - EPG transaction id e.g. "1234"
   * @param {string} md - Merchant details string from 3D Secure
   * @param {string} termUrl - This is the return URL that EPG will use for redirecting back the customer once
   * the payment is completed e.g. "https://www.williamhill.com"
   * @returns {void}
   * **/
  function frictionlessRequest(cardId, pmtId, threeDSv2Token, txnId, md, termUrl, threeDSVersion, methodCompletionInd) {
    return new _promise2.default(function (resolve, reject) {
      var browserData = helper.gatherBrowserData();
      var pmtApi = new _PaymentsApi.PaymentsApi();
      pmtApi.threeDSv2FrictionlessRequest(cardId, pmtId, threeDSv2Token, txnId, md, termUrl, browserData, threeDSVersion, methodCompletionInd).then(function (data) {
        resolve(data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  /** remove3DSv2FrictionlessIframe
   * @returns {void}
   * **/
  function removeFrictionlessIframe() {
    helper.remove3DSv2FrictionlessIframe();
  }

  /** remove3DSv2ChallengeIframe
   * @returns {void}
   * **/
  function removeChallengeIframe() {
    helper.remove3DSv2ChallengeIframe();
  }

  /** completePayment
   * @param {Object} activeDepositData active deposit data
   * @param {Object} data Response from challenge iframe
   * @returns {void}
   * **/
  function complete3DSPayment(activeDepositData, data) {
    return new _promise2.default(function (resolve, reject) {
      var pmtApi = new _PaymentsApi.PaymentsApi();
      pmtApi.complete3DSv2Payment(activeDepositData.cardId, activeDepositData.amount, data.CRes, data.threedsSessionData).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  return {
    get3DDetails: secureDepositV1.get3DDetails,
    complete3DSPayment: complete3DSPayment,
    frictionlessRequest: frictionlessRequest,
    createFrictionlessIframe: createFrictionlessIframe,
    startChallenge: startChallenge,
    removeFrictionlessIframe: removeFrictionlessIframe,
    removeChallengeIframe: removeChallengeIframe
  };
}